import Offer from './Offer'
export default class ConstructionEstimate extends Offer {

    resource()
    {
        return 'construction-estimates'
    }
    get downloadEndpoint() {
        return `${this.endpoint()}/download/offer`
    }

    get downloadFiscalInvoiceEndpoint() {
        return `${this.endpoint()}/download/invoice`
    }
}
